export default __webpack_public_path__ + "images/1925a84c41ab8a0a67d17d5df258e5e1.svg";